"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _first = _interopRequireDefault(require("lodash/first"));
var _get = _interopRequireDefault(require("lodash/get"));
var _includes = _interopRequireDefault(require("lodash/includes"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _reactLoaderSpinner = _interopRequireDefault(require("react-loader-spinner"));
var _utils = require("../../utils");
var _hooks = require("../../hooks");
var _colapsibleSection = _interopRequireDefault(require("./colapsible-section"));
var _generalInfo = _interopRequireDefault(require("./sections/general-info"));
var _itemButton = _interopRequireDefault(require("./item-button"));
var _school = _interopRequireDefault(require("./sections/school"));
var _experience = _interopRequireDefault(require("./sections/experience"));
var _skill = _interopRequireDefault(require("./sections/skill"));
var _diversity = _interopRequireDefault(require("./sections/diversity"));
var _writing = _interopRequireDefault(require("./sections/writing"));
var _whyCompany = _interopRequireDefault(require("./sections/why-company"));
var _preferences = _interopRequireDefault(require("./sections/preferences"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Profile = function Profile(_ref) {
  var student = _ref.student,
    goToUploadPhoto = _ref.goToUploadPhoto,
    goToMyResume = _ref.goToMyResume,
    onSeeking = _ref.onSeeking,
    onClickEdit = _ref.onClickEdit,
    onChangeModal = _ref.onChangeModal,
    isLoading = _ref.isLoading,
    isUpdating = _ref.isUpdating,
    isEdit = _ref.isEdit,
    disabledResume = _ref.disabledResume,
    viewDiversities = _ref.viewDiversities,
    viewProfilePicture = _ref.viewProfilePicture,
    viewWhyCompany = _ref.viewWhyCompany,
    showPrivate = _ref.showPrivate,
    showPhone = _ref.showPhone,
    showProfile = _ref.showProfile,
    applicant = _ref.applicant,
    roundedImage = _ref.roundedImage,
    location = _ref.location,
    hasHighlight = _ref.hasHighlight,
    showContactTagsSelector = _ref.showContactTagsSelector,
    isSavingContactTags = _ref.isSavingContactTags,
    contactTags = _ref.contactTags,
    onContactTag = _ref.onContactTag,
    showContactTags = _ref.showContactTags,
    onSetShowContactTags = _ref.onSetShowContactTags;
  var acronym = "".concat((0, _first.default)((0, _get.default)(student, 'firstName'))).concat((0, _first.default)((0, _get.default)(student, 'lastName')));
  var emojis = (0, _get.default)(student, 'myselfEmoji');
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    showItem = _useState2[0],
    setShowItem = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    hideClassHeader = _useState4[0],
    setHideClassHeader = _useState4[1];
  var _useModal = (0, _hooks.useModal)(null),
    showModal = _useModal.showModal,
    setShowModal = _useModal.setShowModal;
  var diversities = student.diversity.filter(function (diversity) {
    return diversity.added === 1 && diversity.includeOnResume;
  });
  var viewDiversitySection = viewDiversities && !(0, _isEmpty.default)(diversities) || isEdit;
  var links = student.links.filter(function (a) {
    return a.added === 1;
  });
  var viewWritingSection = !(0, _isEmpty.default)(links) || isEdit;
  var skills = student.technicalSkill.filter(function (a) {
    return a.added === 1;
  });
  var languages = student.languages.filter(function (language) {
    return language.added === 1;
  });
  var personalInterests = student.personalInterests.filter(function (a) {
    return a.added === 1;
  });
  var certifications = student.certificationsAndLicences.filter(function (a) {
    return a.added === 1;
  });
  var viewSkills = !(0, _isEmpty.default)(skills) || !(0, _isEmpty.default)(languages) || !(0, _isEmpty.default)(personalInterests) || !(0, _isEmpty.default)(certifications) || isEdit;
  var hasApplicantOfWriting = !!(applicant.transcriptShort || applicant.portfolioUrlShort);
  var viewWhyCompanySection = !!(viewWhyCompany && applicant.whyOurCompanyReason);
  var isIPhone = (0, _includes.default)(navigator.platform, 'iPhone') || (0, _includes.default)(navigator.platform, 'iPad');
  var query = (0, _hooks.useQuery)('origin', location);
  (0, _react.useEffect)(function () {
    if (onChangeModal) {
      onChangeModal(showModal);
    }
  }, [showModal]);
  (0, _react.useEffect)(function () {
    if (!isUpdating) {
      setShowModal(null);
    }
  }, [isUpdating, setShowModal]);
  var scrollToItem = function scrollToItem(id) {
    if (showItem !== id) {
      var divProfile = (0, _utils.getElement)('sidebar-container-profile');
      var itemBlock = (0, _utils.getElement)(id);
      if (itemBlock && divProfile) {
        divProfile.scrollTop = itemBlock.offsetTop - 30;
      }
    }
  };
  var toggleItem = function toggleItem(e) {
    scrollToItem(e.target.id);
    setShowItem(showItem === e.target.id ? '' : e.target.id);
  };
  var handleScroll = function handleScroll() {
    var blankSection = (0, _utils.getElement)('blankSection');
    var blankSectionHeight = blankSection ? blankSection.clientHeight - 100 : 0;
    var divProfile = (0, _utils.getElement)('sidebar-container-profile');
    if (divProfile) {
      var currentScrollY = divProfile.scrollTop;
      if (currentScrollY >= blankSectionHeight) {
        setHideClassHeader('hide');
      } else if (currentScrollY < blankSectionHeight) {
        setHideClassHeader('');
      }
    }
  };
  (0, _react.useEffect)(function () {
    var divProfile = (0, _utils.getElement)('sidebar-container-profile');
    if (!(0, _isEmpty.default)(student)) {
      var blankSection = (0, _utils.getElement)('blankSection');
      var divInfoBody = (0, _utils.getElement)('infoBody');
      if (blankSection && divInfoBody) {
        var infoBodyHeight = divInfoBody.clientHeight;
        blankSection.style.minHeight = "calc(100vh - ".concat(infoBodyHeight + (isIPhone ? 28 : 0), "px)");
      }
      if (divProfile) {
        divProfile.addEventListener('scroll', handleScroll, {
          passive: true
        });
      }
    }
    return function () {
      if (!(0, _isEmpty.default)(student) && divProfile) {
        divProfile.removeEventListener('scroll', handleScroll);
      }
    };
  }, [student]);
  (0, _react.useEffect)(function () {
    if (!isLoading && student && applicant && query === 'pdf') {
      var element = document.getElementById('whyCompany');
      if (element) {
        element.scrollIntoView();
        element.click();
      }
    }
  }, [isLoading, student, applicant, query]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isLoading && student && !(0, _isEmpty.default)(student) && /*#__PURE__*/_react.default.createElement(_styled.Container, {
    id: "sidebar-container-profile",
    withImage: student.photoUrl,
    showPrivate: showPrivate,
    viewDiversities: viewDiversitySection,
    viewWhyCompany: viewWhyCompanySection
  }, isEdit && /*#__PURE__*/_react.default.createElement(_styled.Header, {
    hide: hideClassHeader
  }, /*#__PURE__*/_react.default.createElement(_styled.ButtonCamara, {
    type: "button",
    onClick: goToUploadPhoto
  })), viewProfilePicture && (0, _get.default)(student, 'photoUrl') && /*#__PURE__*/_react.default.createElement(_styled.WrapperImage, {
    roundedImage: roundedImage
  }, /*#__PURE__*/_react.default.createElement(_styled.Image, {
    src: roundedImage ? student.thumbUrl : student.photoUrl,
    roundedImage: roundedImage
  })), /*#__PURE__*/_react.default.createElement(_styled.LevelWrapper, {
    className: "profile-wrapper",
    showPrivate: showPrivate,
    viewDiversities: viewDiversitySection,
    viewWhyCompany: viewWhyCompanySection,
    viewWritingSection: viewWritingSection,
    viewSkills: viewSkills
  }, /*#__PURE__*/_react.default.createElement(_styled.BlankSection, {
    id: "blankSection",
    className: "blank-section"
  }, /*#__PURE__*/_react.default.createElement(_styled.HexagonWrapper, null, (!student.photoUrl || !viewProfilePicture) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styled.Hexagon, null, acronym), /*#__PURE__*/_react.default.createElement(_styled.Emojis, null, /*#__PURE__*/_react.default.createElement("span", {
    role: "img",
    "aria-label": "Emojis"
  }, emojis))))), /*#__PURE__*/_react.default.createElement(_styled.Content, null, /*#__PURE__*/_react.default.createElement(_colapsibleSection.default, {
    isOpen: true,
    className: "info-body",
    id: "infoBody"
  }, /*#__PURE__*/_react.default.createElement(_generalInfo.default, {
    onSeeking: onSeeking,
    goToMyResume: goToMyResume,
    student: student,
    disabledResume: disabledResume,
    showPrivate: showPrivate,
    viewDiversities: viewDiversities,
    showPhone: showPhone,
    applicant: applicant,
    showContactTagsSelector: showContactTagsSelector,
    isSavingContactTags: isSavingContactTags,
    contactTags: contactTags,
    onContactTag: onContactTag,
    showContactTags: showContactTags,
    onSetShowContactTags: onSetShowContactTags
  })), /*#__PURE__*/_react.default.createElement(_itemButton.default, {
    id: "school",
    onClick: toggleItem,
    showItem: showItem,
    description: "School Info"
  }), /*#__PURE__*/_react.default.createElement(_colapsibleSection.default, {
    id: "#school",
    isOpen: showItem === 'school',
    className: "school-body"
  }, /*#__PURE__*/_react.default.createElement(_school.default, {
    onClickEdit: onClickEdit,
    student: student,
    setShowModal: setShowModal,
    isEdit: isEdit,
    showPrivate: showPrivate
  })), /*#__PURE__*/_react.default.createElement(_itemButton.default, {
    id: "experience",
    onClick: toggleItem,
    showItem: showItem,
    description: "Experience",
    viewWhyCompany: viewWhyCompanySection,
    viewDiversities: viewDiversitySection,
    viewWritingSection: viewWritingSection,
    viewSkills: viewSkills
  }), /*#__PURE__*/_react.default.createElement(_colapsibleSection.default, {
    id: "#experience",
    isOpen: showItem === 'experience',
    className: "experience-body",
    timeout: {
      enter: 0,
      exit: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_experience.default, {
    onClickEdit: onClickEdit,
    isOpen: showItem === 'experience',
    goToMyResume: goToMyResume,
    student: student,
    showModal: showModal,
    setShowModal: setShowModal,
    isEdit: isEdit,
    showProfile: showProfile,
    hasHighlight: hasHighlight
  })), viewWhyCompanySection && applicant && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_itemButton.default, {
    id: "whyCompany",
    onClick: toggleItem,
    showItem: showItem,
    description: "Why Our Company",
    viewDiversities: viewDiversitySection,
    viewWritingSection: viewWritingSection,
    viewSkills: viewSkills
  }), /*#__PURE__*/_react.default.createElement(_colapsibleSection.default, {
    id: "#whyCompany",
    isOpen: showItem === 'whyCompany',
    className: "why-company-body",
    timeout: {
      enter: 0,
      exit: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_whyCompany.default, {
    applicant: applicant
  }))), viewSkills && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_itemButton.default, {
    id: "skill",
    onClick: toggleItem,
    showItem: showItem,
    description: "Skills & interests",
    viewDiversities: viewDiversitySection,
    viewWritingSection: viewWritingSection
  }), /*#__PURE__*/_react.default.createElement(_colapsibleSection.default, {
    id: "#skill",
    isOpen: showItem === 'skill',
    className: "skill-body",
    timeout: {
      enter: 0,
      exit: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_skill.default, {
    onClickEdit: onClickEdit,
    student: student,
    isEdit: isEdit
  }))), viewDiversitySection && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_itemButton.default, {
    id: "diversity-inclusion",
    onClick: toggleItem,
    showItem: showItem,
    description: "My Diversities",
    viewWritingSection: viewWritingSection
  }), /*#__PURE__*/_react.default.createElement(_colapsibleSection.default, {
    id: "#diversity-inclusion",
    isOpen: showItem === 'diversity-inclusion',
    className: "diversity-inclusion-body",
    timeout: {
      enter: 0,
      exit: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_diversity.default, {
    includeOnResume: student.includeDiversityInclusionsResume,
    onClickEdit: onClickEdit,
    diversities: diversities,
    isEdit: isEdit,
    showPrivate: showPrivate,
    viewDiversities: viewDiversities
  }))), viewWritingSection && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_itemButton.default, {
    id: "writing",
    onClick: toggleItem,
    showItem: showItem,
    description: "Writing Samples",
    smallDescription: "And other links",
    showPrivate: showPrivate
  }), /*#__PURE__*/_react.default.createElement(_colapsibleSection.default, {
    id: "#writing",
    isOpen: showItem === 'writing',
    className: "writing-body",
    timeout: {
      enter: 0,
      exit: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_writing.default, {
    hasApplicantOfWriting: hasApplicantOfWriting,
    links: links,
    onClickEdit: onClickEdit,
    isEdit: isEdit,
    applicant: applicant
  }))), showPrivate && /*#__PURE__*/_react.default.createElement(_itemButton.default, {
    id: "preferences",
    onClick: toggleItem,
    showItem: showItem,
    description: "Preferences",
    smallDescription: "And account information"
  }), /*#__PURE__*/_react.default.createElement(_colapsibleSection.default, {
    id: "#preferences",
    isOpen: showItem === 'preferences',
    className: "preferences-body",
    timeout: {
      enter: 0,
      exit: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_preferences.default, {
    onClickEdit: onClickEdit,
    viewDiversities: viewDiversities,
    student: student,
    isEdit: isEdit,
    setShowModal: setShowModal,
    showPrivate: showPrivate
  }))))), isLoading && /*#__PURE__*/_react.default.createElement(_styled.Loading, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactLoaderSpinner.default, {
    type: "TailSpin",
    color: "rgb(92, 92, 92)",
    height: 80,
    width: 80
  }))));
};
Profile.propTypes = {
  student: _utils.studentProps,
  applicant: _utils.applicantPropTypes,
  isLoading: _propTypes.default.bool,
  isUpdating: _propTypes.default.bool,
  disabledResume: _propTypes.default.bool,
  isEdit: _propTypes.default.bool,
  showContactTagsSelector: _propTypes.default.bool,
  goToUploadPhoto: _propTypes.default.func,
  goToMyResume: _propTypes.default.func,
  onClickEdit: _propTypes.default.func,
  onSeeking: _propTypes.default.func,
  onChangeModal: _propTypes.default.func,
  onContactTag: _propTypes.default.func,
  onSetShowContactTags: _propTypes.default.func,
  viewDiversities: _propTypes.default.bool,
  viewProfilePicture: _propTypes.default.bool,
  viewWhyCompany: _propTypes.default.bool,
  showPrivate: _propTypes.default.bool,
  showPhone: _propTypes.default.bool,
  showProfile: _propTypes.default.bool,
  hasHighlight: _propTypes.default.bool,
  roundedImage: _propTypes.default.bool,
  isSavingContactTags: _propTypes.default.bool,
  showContactTags: _propTypes.default.bool,
  location: _propTypes.default.shape({
    search: _propTypes.default.shape({})
  }),
  contactTags: _utils.contactTagsPropTypes
};
Profile.defaultProps = {
  student: {
    seeking: false
  },
  applicant: {},
  isLoading: false,
  isUpdating: false,
  disabledResume: false,
  isEdit: true,
  goToUploadPhoto: function goToUploadPhoto() {
    return {};
  },
  goToMyResume: function goToMyResume() {
    return {};
  },
  onClickEdit: function onClickEdit(path, showEditPage) {
    return console.info({
      path: path,
      showEditPage: showEditPage
    });
  },
  onSeeking: function onSeeking() {
    return {};
  },
  onChangeModal: undefined,
  onContactTag: undefined,
  onSetShowContactTags: undefined,
  viewDiversities: true,
  viewProfilePicture: true,
  viewWhyCompany: false,
  showPrivate: false,
  showPhone: false,
  showProfile: false,
  roundedImage: false,
  hasHighlight: false,
  showContactTagsSelector: false,
  isSavingContactTags: false,
  showContactTags: false,
  location: undefined,
  contactTags: []
};
var _default = Profile;
exports.default = _default;